<template>
  <div class="columns is-multiline is-main-content is-marginless is-paddingless"
       v-if="newCritereRecherche">
    <div class="column is-12 pdb-0 hauteur-haut-brief-filtre">
      <div class="column is-12 mgt-5px">
        <a @click="$emit('toggleFiltre')">
          <b-icon class="icon is-pulled-right has-text-icon-more" icon="close"></b-icon>
        </a>
        <span class="has-text-weight-bold is-size-4">
          {{ $t('listeCollectivite.filtre.title') }}
        </span>
      </div>
      <div class="column is-12 pdt-0">
        <span class="has-text-icon-more is-size-7">
          {{ $t('listeCollectivite.filtre.sousTitle') }}
        </span>
      </div>
    </div>
    <div class="column is-12 overflow-auto is-marginless hauteur-brief-filtre">
        <div class="column is-12 pdb-0">
          <query-fournisseur-tag-input
            v-model="newCritereRecherche.tiers"
            :societeActiveId="societeActiveId"
            :label="$t('listeCollectivite.filtre.collectivites')"
            :sousType="[constantes.TIERS_SOUS_TYPE_COLLECTIVITE]">
          </query-fournisseur-tag-input>
        </div>
      <div class="column is-12 pdb-0">
        <b-field :label="$t('listeCollectivite.filtre.nom')">
          <b-input v-model="newCritereRecherche.nomCommercial"></b-input>
        </b-field>
      </div>
      <div class="column is-12 pdb-0">
        <b-field :label="$t('listeCollectivite.filtre.adresse')">
          <b-input v-model="newCritereRecherche.adresse"></b-input>
        </b-field>
      </div>
      <div class="column is-12 pdb-0">
        <b-field :label="$t('listeCollectivite.filtre.departement')">
          <qd-taginput
              v-model="newCritereRecherche.depts"
              ellipsis
              type="is-primary">
          </qd-taginput>
        </b-field>
      </div>
      <div class="column is-12 pdb-0">
        <b-field :label="$t('listeCollectivite.filtre.ville')">
          <ville-tag-input-auto-complete
              :critere-recherche="newCritereRecherche"
              table-name="Tiers"/>
        </b-field>
      </div>
      <div class="column is-12 pdb-0">
        <b-field :label="$t('listeCollectivite.filtre.compteComptable')">
          <b-input v-model="newCritereRecherche.compteComptable">
          </b-input>
        </b-field>
      </div>
      <div class="column is-12 pdb-0">
        <b-field :label="$t('listeCollectivite.filtre.email')">
          <b-input v-model="newCritereRecherche.email">
          </b-input>
        </b-field>
      </div>
      <div class="column is-12 pdb-0">
        <b-field :label="$t('listeCollectivite.filtre.telephone')">
          <b-input v-model="newCritereRecherche.telephone">
          </b-input>
        </b-field>
      </div>
      <div class="column is-12 pdb-0">
        <agence-tag-input
                      :label="$t('listeCollectivite.filtre.agence')"
                      :items="agencesSelectionnees"
                      v-model="newCritereRecherche.agencesId">
        </agence-tag-input>
      </div>
      <div class="column is-4 pdb-0">
        <b-field :label="$t('listeCollectivite.filtre.archiver')">
          <b-select v-model="newCritereRecherche.archive">
            <option :value="null"></option>
            <option :value="true"> {{ $t('general.oui') }}
            </option>
            <option :value="false"> {{ $t('general.non') }}
            </option>
          </b-select>
        </b-field>
      </div>
    </div>
    <div class="column is-12 border-pied pdt-0 hauteur-bas-brief-filtre">
      <button class="button mgl-10px mgt-10px is-addOrEdit has-text-white"
              @click="appliquerCritere()">
        {{ $t('listeCollectivite.filtre.actions.appliquer') }}
      </button>

      <button @click="viderCritere()"
              class="button border-none mgt-10px has-text-icon-more pd-10px">
        {{ $t('listeCollectivite.filtre.actions.reinitialiser') }}
      </button>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import messageErreur from '@/services/general/messageErreur';
import genererCritereRechercheCollectivite from '@/services/gabed/collectivite/genererCritereRecherche';
import VilleTagInputAutoComplete from '@/components/commun/ville/villeTagInputAutoComplete';
import { TIERS_SOUS_TYPE_COLLECTIVITE } from '@/configuration/tiers/tiersConf';
import agenceTagInput from '@/components/general/tagInput/agenceTagInput';
import queryFournisseurTagInput from '@/components/general/tagInput/queryFournisseurTagInput';

const Societe = createNamespacedHelpers('societe');

export default {
  components: {
    agenceTagInput,
    VilleTagInputAutoComplete,
    queryFournisseurTagInput,
  },
  data() {
    return {
      newCritereRecherche: null,
      constantes: {
        TIERS_SOUS_TYPE_COLLECTIVITE: TIERS_SOUS_TYPE_COLLECTIVITE,
      },
    };
  },
  props: {
    critereRecherche: {
      type: Object,
      required: true,
    },
  },
  methods: {
    appliquerCritere() {
      this.$emit('recherche', this.newCritereRecherche);
    },
    viderCritere() {
      this.newCritereRecherche = genererCritereRechercheCollectivite();
    },
    initializeFiltre() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        this.newCritereRecherche = cloneDeep(this.critereRecherche);
        loadingComponent.close();
      } catch (e) {
        messageErreur(this.$i18n);
        loadingComponent.close();
        throw e;
      }
    },
  },
  computed: {
    ...Societe.mapGetters({
      agencesSelectionnees: 'agenceActive',
      societeActiveId: 'societeActiveId',
    }),
  },
  mounted() {
    this.initializeFiltre();
  },
};
</script>

<style scoped>

</style>
